import { calendar_v3 } from "googleapis";

export function isEventOccurringToday(event: calendar_v3.Schema$Event) {
  const startDateString = event.start?.dateTime ?? event.start?.date ?? "";
  if (!startDateString) {
    return false;
  }

  const startOfToday = new Date();
  startOfToday.setHours(0, 0, 0, 0);

  const endOfToday = new Date();
  endOfToday.setHours(23, 59, 59, 999);

  const eventDate = new Date(startDateString);
  return eventDate >= startOfToday && eventDate <= endOfToday;
}
